/* eslint-disable @typescript-eslint/no-explicit-any */

const createFormatter = (culture: string): Intl.NumberFormat => {
  const formatOptions = {
    trailingZeroDisplay: 'stripIfInteger',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }

  return new Intl.NumberFormat(culture, formatOptions)
}

export default class NumberFormatter {
  static _formatters: any = {}

  static getInstance(): Intl.NumberFormat {
    const culture = 'en-gb'
    const formatterKey = `culture_${culture}`
    let targetFormatter = NumberFormatter._formatters[formatterKey]
    if (!targetFormatter) {
      targetFormatter = createFormatter(culture)
      NumberFormatter._formatters[formatterKey] = targetFormatter
    }
    return targetFormatter
  }
}
